import config from '@app/config';
import { fetchFetMarksByParamDisks, fetchFetMarksByParamTyres } from '@entities/Auto';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { typeDiskLink } from '../helper/conversionValue/conversionValue';
import { Part, Product, ProductSpecCode } from '../types/productSchema';
import { ProductInfoDto } from './api.dto';

export const getProductMainData = createAsyncThunk<Product, ProductInfoDto>('product/getProductMainData', async (query, Api) => {
  const url =
    `/api/products/${query.slug}?regionId=${query.regionId}` +
    `${query.brand ? `&brand=${query.brand}` : ''}` +
    `${query.model ? `&model=${query.model}` : ''}` +
    `${query.part ? `&part=${query.part}` : ''}`;

  const product: Product = await MyAxios.get(url)
    .then(handleResponse)
    .catch(error => handleError(error, null));

  const safeModeFitsTheCarByCartProduct = config.safeModeFitsTheCarByCartProduct === 'true';

  if (product?.part === Part.Tyres) {
    const query = {
      width: +product.productSpecs.find(spec => spec.code === ProductSpecCode.Width)?.value,
      height: +product.productSpecs.find(spec => spec.code === ProductSpecCode.Height)?.value,
      diam: +product.productSpecs.find(spec => spec.code === ProductSpecCode.Diameter)?.value,
    };
    !safeModeFitsTheCarByCartProduct && (await Api.dispatch(fetchFetMarksByParamTyres(query)));
  } else if (product?.part === Part.Disks) {
    const query = {
      width: +product.productSpecs.find(spec => spec.code === ProductSpecCode.DiskWidth)?.value,
      diam: +product.productSpecs.find(spec => spec.code === ProductSpecCode.DiskRadius)?.value,
      pcdc: product.productSpecs.find(spec => spec.code === ProductSpecCode.DiskPcde)?.value + '',
      pcdd: product.productSpecs.find(spec => spec.code === ProductSpecCode.DiskPcdd)?.value + '',
      dia: product.productSpecs.find(spec => spec.code === ProductSpecCode.DiskDia)?.value + '',
      et: product.productSpecs.find(spec => spec.code === ProductSpecCode.DiskEt)?.value + '',
    };
    product.productSpecs.push({
      code: ProductSpecCode.DiskUnitedPcd,
      title: 'PCD',
      value: `${query.pcdc}*${query.pcdd}`,
    });
    const typeDisk = product.productSpecs.find(x => x.code === ProductSpecCode.DiskType);
    if (typeDisk) {
      typeDisk.href = typeDiskLink[Number(typeDisk.value)];
    }

    !safeModeFitsTheCarByCartProduct && (await Api.dispatch(fetchFetMarksByParamDisks(query)));
  } else if (product?.part === Part.Batteries) {
    const capacity = product.productSpecs.find(x => x.code === ProductSpecCode.AkbCapacity);
    if (capacity) {
      capacity.href = `/catalog/accumulators/capacity/${capacity.value}/`;
    }
  }

  return product;
});
